import 'angular';
import '../../../../../lib/assets/javascripts/devex/util';
import '../services/organization.service';
import routesModule from '../../../utilities/routes_module';
import template from './report_summary.template.html?raw';

const reportSummaryController = function(Organization) {
  const that = this;

  that.showOrganizationLink = Organization.showOrganizationLink;
  that.organizationDetailsUrl = routesModule.organization_path;
  that.numberToHuman = devex.util.numberToHuman;

  that.reportOfType = types => {
    return devex.util.propertyIncludes(that.report.type, types);
  };

  /**
   * Checks if the property exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {string} prop - Property to be checked
   * @returns {boolean} true if the property exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsValid = prop => devex.util.containsProp(that.report, prop);

  /**
   * Checks if any of the properties exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {Array.<string>} props - Properties to be checked, passed as strings
   * @returns {boolean} true if any of the properties exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsAnyValid = props => devex.util.containsAnyProp(that.report, props);

  /**
   * Check that report contains all fields passed as an array. If any is null, empty or false,
   * returns false
   *
   * @param {Array.<string>} props - An array of properties as strings
   *
   * @returns {boolean} - True if all fields are present, false if any is missing
   */
  that.reportContainsEveryValid = props => devex.util.containsAllProps(that.report, props);

  that.showOtherInfo = () => {
    const propertiesToCheck = [
      'opportunity_size',
      'lead_funder_contribution',
      'deadline',
      'categories',
      'reference_number',
      'sectors',
      'executing_agency',
      'value'
    ];

    if(!that.reportOfType('contract')) {
      propertiesToCheck.push('organizations');
    }

    return that.reportContainsAnyValid(propertiesToCheck);
  };

  /**
   * Before displaying lead funder contribution, we need check that all required fields are
   * present AND if the lead funder contribution is diifferent from value of the report.
   *
   * @returns {boolean} - True to display lead funder contribution DOM, false otherwise
   */
  that.isLeadFunderContributionVisible = () => {
    const fields = ['lead_funder_contribution', 'donors', 'currency', 'value'];
    return that.reportContainsEveryValid(fields) && !!that.report.currency.alpha3 &&
      that.report.value !== that.report.lead_funder_contribution;
  };

  /**
   * Before displaying supporting funders contribution, check that all required fields are
   * present.
   *
   * @returns {boolean} - True to display supporting funder contribution DOM, false otherwise
   */
  that.isSupportingFundersContributionVisible = () => {
    const fields = ['supporting_funders_contribution', 'donors', 'currency'];
    return that.reportContainsEveryValid(fields) && !!that.report.currency.alpha3;
  };

  that.getDeadlineType = () => {
    const report = that.report;
    let result = 'Proposal due date';

    if(report.deadline === report.express_interest_by_date) {
      result = 'Express interest by date';
    } else if(report.deadline === report.pre_qualification_date) {
      result = 'Pre qualification date';
    }

    return result;
  };
};

const controller = ['Organization', reportSummaryController];

const moduleDependencies = ['fundingSearchApp.services.Organization'];

angular
  .module('fundingSearchApp.components.reportSummary', moduleDependencies)
  .run(['$templateCache', $templateCache => {
    $templateCache.put(template, template);
  }])
  .component('reportSummary', {
    controller,
    templateUrl: template,
    bindings: {
      report: '='
    },
    controllerAs: 'vm'
  });
